import React from 'react';

import ABTest from '../../abtest/index';
import QuestionContainer from './question-container';
import { withError } from '../../shared/components/error-boundary';

import './questionnaire.less';

export default withError(({}) => {
    return (
        <ABTest experimentID="ProductQuestioneer" ssrRender={true}>
            {data => {
                const { title, questionAndAnswers: questions, finderPage, resultTitle, resultDescription } = data || {};
                if (!questions || !questions.length) {
                    return null;
                }
                return (
                    <div className="questionnaire">
                        <QuestionContainer
                            title={title}
                            questions={questions}
                            finderPage={finderPage}
                            resultTitle={resultTitle}
                            resultDescription={resultDescription}
                        />
                    </div>
                );
            }}
        </ABTest>
    );
});
